import React, { useState } from 'react'
import { AddPageServicesApi } from '../../API/AdminServices'
import Button from '../../Components/Button/Button'
import Editor from '../../Components/Editor/Editor'
import Input from '../../Components/Input/Input'
import { errorToast, succToast } from '../../Toast/Toast'
import Style from './AddPage.module.css'
const AddPage = () => {
    const[description,setDescription]=useState('')
    const[enName,setEnName]=useState('')
    const[faName,setFaName]=useState('')
    const[showState,setShowState]=useState(false)
    // console.log(showState)
    const AddPageHandler=()=>{
        if(enName==='' || faName===''){
            errorToast('لطفا نام هارو وارد کنید')
        }
        else if(enName.indexOf(' ') >= 0){
            errorToast('نام انگلیسی را بدون فاصله وارد کنید')
        }
        else{
            let info={
                page:enName,
                title:faName,
                content:description,
                status:showState?'0':'1'
            }
            AddPageServicesApi(info,(succ)=>{
                if(succ.status===1){
                    succToast(succ.message)
                    setEnName('')
                    setFaName('')
                    setDescription('')
                }
                else{
                    errorToast(succ.message)
                }
            })
        }
    }
    return (
        <div className={Style.PageHolder}>
            <div className={Style.Pageinfo}>
                <Input value={enName} onChange={e=>setEnName(e.target.value)} placeholder='اسم صفحه به انگلیسی' />
                <Input value={faName} onChange={e=>setFaName(e.target.value)} placeholder='اسم صفحه به فارسی'/>
                <a href={`https://electronicsteps.ir/${enName}`} rel='noreferrer' target="_blank" >{`www.electronicsteps.ir/${enName}`}</a>
            </div>
            <Editor
            desc={description}
            setdescription={setDescription}
            />
            <div className={Style.ShowPageStyle}>
                <label htmlFor="show">درسایت نمایش داده نشود</label>
                <input type="checkbox"  id='show' onChange={e=>setShowState(e.target.checked)}/>
            </div>
            <Button Value={'افزودن'} ClassBtn={'confirmBtn'}  clickhandler={AddPageHandler}/>
        </div>
    )
}

export default AddPage
